export const environment = {
  production: true,
  storefrontApiUrl: 'https://mypoolhut.myshopify.com/api/graphql',
  graphQlUrl: 'https://mypoolhut.myshopify.com/api/2026-01/graphql.json',
  shopifyaccesstoken: '465cacf41f3298cf0b87b7d750f62c6c',
  syncApiUrl: 'https://notificationapi.mypoolhut.com'
};
